export default __webpack_public_path__ + "static/media/SEA_7384.0e1ec867.jpg";